import {useRef} from 'react';

/** Freezes the last value while closed, so the exit animation doesn't render empty content. */
const useStickyWhileOpen = <T>(value: T, isOpen: boolean): T => {
    const ref = useRef(value);

    if (isOpen) ref.current = value;

    return ref.current;
};

export default useStickyWhileOpen;
